/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Payments_ProviderInputs */

const en_admin_payments_provider = /** @type {(inputs: Admin_Payments_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provider`)
};

const zh_admin_payments_provider = /** @type {(inputs: Admin_Payments_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支付方式`)
};

/**
* | output |
* | --- |
* | "Provider" |
*
* @param {Admin_Payments_ProviderInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_payments_provider = /** @type {((inputs?: Admin_Payments_ProviderInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Payments_ProviderInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_payments_provider(inputs)
	return zh_admin_payments_provider(inputs)
});
export { admin_payments_provider as "admin.payments.provider" }